import createModule from "../createModule"
import view from "./view"
import "./style.scss"
import { getAnalyzeMenuItems } from "./selectors"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    menuItems: getAnalyzeMenuItems(state, props),
  }),
})
